module.exports = __webpack_public_path__ + "static/process_img_card2-11bfdba71ffe4b9640f556999cf8010d.png";